import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
  SwipeTabs,
  SwipeTab,
  DateRangeField,
} from "../../styles/Global";
import moment from "moment";
import * as Global from "../../styles/Global";
import { ImInfo } from "react-icons/im";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import StatBlock from "../player/StatBlock";
import { FaUserCircle, FaQrcode } from "react-icons/fa";
import "../../App.scss";
import { IoMdNotifications } from "react-icons/io";
import UpgradeBlurComponent from "../../components/UpgradeBlurComponent";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import { useGetTournamentAlertsMutation } from "../../services/organizerApi";
import SkeletonLoader from "../../components/SkeletonLoader";
import SwipeCharts from "../charts/SwipeCharts";
import { BiRefresh } from "react-icons/bi";
import { setModal, clearModals } from "../../features/modals/modalSlice";
import { setRefreshTournamentAlerts } from "../../features/refreshScreen/refreshScreenSlice";
import { toast } from "react-toastify";
import { OpenExternalURL } from "../../functions/helperFunctions";
//End AG-Grid
const mapDispatch = { setModal, setRefreshTournamentAlerts, clearModals };

const AlertsSection = ({ setModal, setRefreshTournamentAlerts }) => {
  const organizer = useSelector((state) => state.organizer.organizerData);
  const refreshTournamentAlerts = useSelector(
    (state) => state.refresh.refreshTournamentAlerts
  );
  const platform = useSelector((state) => state.organizer.platform);
  const [modalType, setModalType] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [nextAlertAvail, setNextAlertAvail] = useState(false);
  const today = moment();
  const [alerts, setAlerts] = useState([]);
  const [alertData, setAlertData] = useState({});
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const [
    getAlerts,
    { isLoading: getAlertsLoading, error: getAlertsError, data: getAlertsData },
  ] = useGetTournamentAlertsMutation();

  console.log("getAlertsData: ", getAlertsData);
  console.log("nextAlertAvail: ", nextAlertAvail);
  console.log("refreshTournamentAlerts: ", refreshTournamentAlerts);

  useEffect(() => {
    getAlerts({ sport });
  }, [refreshTournamentAlerts]);

  useEffect(() => {
    if (getAlertsData && getAlertsData.statusCode === 0) {
      console.log("getAlertsData setting new data...: ", getAlertsData);
      setAlerts(getAlertsData.rows);
      setAlertData(getAlertsData);
      if (moment().isSameOrAfter(moment(getAlertsData.nextAlertSend))) {
        console.log("setting nextAlertAvail from new alertData info");
        setNextAlertAvail(true);
      } else {
        setNextAlertAvail(false);
      }
    }
  }, [getAlertsData]);

  function ShowModalType(type) {
    setModalType(type);
    setShowModal(true);
  }

  function OpenInfoLink() {
    const url =
      "https://docs.scoreholio.com/run-a-tournament/promotional-alerts";
      OpenExternalURL(url, platform);
  }

  function SetAlertColor(opacity, type) {
    let color = "#fff";
    switch (type) {
      case "Singles":
        color = `#d07a2d${opacity}`;
        break;
      case "single":
      case "Organizer":
        color = `#43922a${opacity}`;
        break;
      case "all":
      case "Tournament":
        color = `#3576a4${opacity}`;
        break;
      case "Switcholio":
        color = `#4b3179${opacity}`;
        break;
      case "Squadholio":
        color = `#bb9b34${opacity}`;
        break;
      default:
        color = `#333${opacity}`;
        break;
    }
    return color;
  }

  window.refreshAlerts = async function () {
    try {
      console.log("window.refreshAlerts");
      toast.success("Alert purchase complete!");
      setTimeout(() => {
        setRefreshTournamentAlerts();
      }, 2000);
      setModal({
        orgModals: {
          showModal: false,
          modalType: 19,
        },
      });
    } catch (error) {
      console.log(error);
      console.log("indow.refreshAlerts ERROR: ", error);
    }
  };

  return getAlertsData && getAlertsData.statusCode === 0 ? (
    <>
      {organizer.subLevelNum === 0 ? (
        <FlexRow align="center" justify="center">
          <UpgradeBlurComponent
            isVisible={true}
            buttonText="Upgrade to send Alerts!"
            buttonStyle={{ width: 250 }}
            children={<div style={{ width: "100%", height: 150 }}></div>}
          />
        </FlexRow>
      ) : (
        <FlexColumn style={{ padding: 10, width: "100%" }}>
          <FlexRow
            align="center"
            justify="space-between"
            style={{ width: "100%" }}
          >
            <div
              // align="center"
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                // border: "1px solid black",
              }}
              onClick={
                () => OpenInfoLink()
                // setModal({
                //   orgTournamentInfo: {
                //     showModal: true,
                //     modalType: 16,
                //     data: {
                //       infoType: "promoAlertInfo",
                //       detailsType: "promoAlertDetails",
                //       heading: "Promotional Alerts",
                //     },
                //   },
                // })
              }
            >
              <ImInfo size={20} color={Global.red} />
              <Text
                style={{ marginLeft: 5, marginTop: 3 }}
                size=".8em"
                color="red"
              >
                What are promotional alerts?
              </Text>
            </div>
            <BiRefresh
              size={30}
              color={Global.blueLight}
              style={{
                cursor: "pointer",
                padding: 2,
                // marginTop: 5,
                // marginLeft: 10,
                backgroundColor: "transparent",
                borderRadius: 20,
              }}
              onClick={() => setRefreshTournamentAlerts()}
            />
          </FlexRow>
          <FlexColumn
            align="center"
            style={{ width: "100%", margin: "15px 0 10px" }}
          >
            <Text size=".8em" style={{ textAlign: "center", marginBottom: 3 }}>
              You can send 1 promotional alert per hour.
            </Text>
            <Text size=".8em" style={{ textAlign: "center" }}>
              PRO subscribers get 2 free credits per month. Credits are awarded
              on account purchase/renewal date. 2 for monthly plans and 24 for
              annual plans.
            </Text>
            <FlexRow
              style={{ marginTop: 20, marginBottom: 10 }}
              justify="center"
              align="center"
            >
              <Text>{alertData.alertCredits} alerts remaining</Text>
              <LargeButtonSecondary
                onClick={() =>
                  setModal({
                    orgModals: {
                      showModal: true,
                      modalType: 19,
                    },
                  })
                }
                style={{ padding: "5px 7px", marginLeft: 10 }}
              >
                <ButtonText secondary style={{ fontSize: ".6em" }}>
                  Get More
                </ButtonText>
              </LargeButtonSecondary>
            </FlexRow>
          </FlexColumn>
          <FlexRow align="center" justify="center" style={{ width: "100%" }}>
            <LargeButton
              onClick={() =>
                setModal({
                  orgModals: {
                    showModal: true,
                    modalType: 18,
                    data: { alerts, alertData, nextAlertAvail },
                  },
                })
              }
            >
              <ButtonText style={{ alignItems: "center" }}>
                Create Promo
              </ButtonText>
              <IoMdNotifications
                style={{ marginLeft: 5 }}
                color="#fff"
                size={18}
              />
            </LargeButton>
          </FlexRow>
          <FlexRow justify="center" style={{ width: "100%" }}>
            {!nextAlertAvail && (
              <Text size=".7em" style={{ marginTop: 10 }}>
                Next alert available{" "}
                {moment(alertData.nextAlertSend).format("MMM DD h:mma")}
              </Text>
            )}
          </FlexRow>

          <FlexColumn align="center" style={{ width: "100%", marginTop: 20 }}>
            {alerts.length > 0 ? (
              alerts.map((alert) => {
                return (
                  <FlexColumn
                    key={alert.alertId}
                    align="stretch"
                    style={{
                      flex: 1,
                      width: "100%",
                      borderRadius: 10,
                      padding: 5,
                      margin: "0 3px",
                      backgroundColor: SetAlertColor(20, alert.alertType),
                      marginBottom: 5,
                      marginTop: 3,
                      border: "1px solid #949CC160",
                      borderColor: SetAlertColor(99, alert.alertType),
                      position: "relative",
                    }}
                    id={alert.alertId}
                  >
                    <FlexRow
                      justify="space-between"
                      style={{ alignSelf: "stretch", marginBottom: 10 }}
                    >
                      <FlexRow align="center">
                        <FlexColumn>
                          <Text
                            size="1em"
                            style={{
                              margin: "5px 5px 0",
                              fontWeight: "700",
                              flex: 2,
                            }}
                          >
                            {alert.tournamentName}
                          </Text>
                        </FlexColumn>
                      </FlexRow>
                      <FlexColumn
                        align="flex-end"
                        style={{ marginTop: 5, flex: 1 }}
                      >
                        <Text
                          size=".8em"
                          style={{
                            paddingRight: 5,
                            whiteSpace: "normal",
                            textAlign: "right",
                          }}
                        >
                          {moment(alert.sendDate, "X").format(
                            "MMM DD, YYYY h:mma"
                          )}
                        </Text>
                        <FlexRow
                          align="center"
                          justify="flex-end"
                          style={{ flex: 1, paddingRight: 5 }}
                        >
                          <Text
                            size=".8em"
                            style={{ fontWeight: "800", textAlign: "right" }}
                          >
                            {alert.alertStatus === "Sending"
                              ? "Sending..."
                              : `${alert.alertSendCount} players reached`}
                          </Text>
                        </FlexRow>
                      </FlexColumn>
                    </FlexRow>
                    <Text
                      size=".8em"
                      style={{
                        overflow: "hidden",
                        width: "97%",
                        margin: "0 5px",
                      }}
                    >
                      {alert.alertMessage}
                    </Text>
                  </FlexColumn>
                );
              })
            ) : getAlertsLoading ? (
              <SkeletonLoader />
            ) : (
              <Text>0 Alerts sent.</Text>
            )}
          </FlexColumn>
        </FlexColumn>
      )}
    </>
  ) : (
    <div style={{ padding: 15 }}>
      <SkeletonLoader />
    </div>
  );
};

export default connect(null, mapDispatch)(AlertsSection);
